export interface IChatAccess {
  hasAccess: boolean;
  bannedUntil?: Date;
  banReason?: string;
}
